import { Injectable } from '@angular/core';
import { MessageService } from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  constructor(private messageService: MessageService) { }

  showSuccess(summary: string) {
    this.messageService.add({ severity: 'success', summary: summary, life: 1000 });
  }

  showHttpError(type: string, summary: string | any, message: string, error?: any) {
    if (typeof summary === "object" && summary.error) summary = summary.error;
    if (!summary && error && error.statusText) summary = error.statusText;
    if (typeof summary == "string" && summary.match(/duplicate/i)) summary = "Duplicate Entry";
    this.messageService.add({ severity: type, summary: summary, detail: message, life: 3000 });
    if (error) console.error(error);
  }

}
